<template>
  <MenuNavbar class="header__menu" :type="vertical ? 'vertical' : null">
    <MenuSidebarItem name="CategoriesNavbarSidebar" direction="left">Categorias</MenuSidebarItem>
    <MenuSidebarItem name="user/UserRankSidebar" direction="right" size="full">Estudantes</MenuSidebarItem>
    <MenuSidebarItem name="ToolsNavbarSidebar" direction="left">Ferramentas</MenuSidebarItem>
    <MenuItem @click="handleTrail">Trilha</MenuItem>

    <MenuLinkItem
      v-if="hasUserSubscriptionAccess"
      :to="{ name: 'lives.premium' }"
    >Lives</MenuLinkItem>

    <MenuLinkItem
      :to="{ name: 'other.become-teacher' }"
    >Seja instrutor</MenuLinkItem>

    <MenuLinkItem
      class="menu__item__link"
      :to="{ name: 'affiliate' }"
      :highlight="false"
    >Afilie-se</MenuLinkItem>
  </MenuNavbar>
</template>

<script>
  import { mapGetters } from 'vuex'
  import MenuNavbar from '@/components/menu/MenuNavbar'
  import MenuLinkItem from '@/components/menu/MenuLinkItem'
  import MenuSidebarItem from '@/components/menu/MenuSidebarItem'
  import MenuItem from '@/components/menu/MenuItem'

  export default {
    components: {
      MenuNavbar,
      MenuLinkItem,
      MenuSidebarItem,
      MenuItem,
    },

    props: {
      vertical: { type: Boolean, default: false }
    },

    computed: {
      ...mapGetters('user', ['isLogged', 'user', 'hasUserSubscriptionAccess'])
    },

    methods: {
      handleTrail() {
        if (!this.isLogged || !this.user.settings.current_trail) {
          this.$router.push({ name: 'trail.pick' })
        } else {
          this.$router.push({ name: 'trail.my' })
        }
      }
    }
  }
</script>
